/** Dansk. */
export default {
  header: {
    features: 'Funktioner',
    pricing: 'Priser',
    contact: 'Kontakt',
    getStarted: 'Kom i gang',
    login: 'Log ind',
  },

  footer: {
    description:
      'En platform til medlemmer, udlejning af lokaler, arrangementer og regnskab, lavet til foreninger.',
    product: 'Produkt',
    help: 'Hjælp',
    legal: 'Juridisk',
    features: 'Funktioner',
    pricing: 'Priser',
    getStarted: 'Kom i gang',
    contactUs: 'Kontakt os',
    privacy: 'Privatliv',
    terms: 'Vilkår',
    copyright: 'Alle rettigheder forbeholdes.',
  },

  home: {
    unknownTenant:
      'Fandt ingen aktiv forening på {host}. Hvis foreningen lige er blevet oprettet, kan det tage nogle minutter, før siden er klar - prøv at genindlæse siden om lidt. Er du usikker på adressen, eller fortsætter problemet, så',
    unknownTenantHere: 'denne adresse',
    unknownTenantContact: 'kontakt os',
    heroTitlePre: 'Digitalisér din forening med',
    heroSubtitle:
      'En platform til medlemmer, udlejning af lokaler, arrangementer og regnskab, lavet til foreninger.',
    ctaFree: 'Kom i gang gratis',
    learnMore: 'Læs mere',
    featuresTitle: 'Det du skal bruge for at drive foreningen',
    featuresSubtitle: 'Værktøjerne samlet i én platform',
    features: [
      { icon: '👥', title: 'Medlemsregister', desc: 'Medlemmer, medlemskaber og husstande, med faktura når medlemskabet fornyes.' },
      { icon: '🏠', title: 'Udlejning af lokaler', desc: 'Booking med priser, kontrakt, depositum og faktura.' },
      { icon: '📅', title: 'Arrangementer', desc: 'Billetsalg med kapacitet, og QR-kode ved døren.' },
      { icon: '💳', title: 'Faktura og betaling', desc: 'Fakturaer og kreditnotaer, og betaling med kort og Vipps via Nets.' },
      { icon: '📧', title: 'E-mail og SMS', desc: 'Bekræftelser, påmindelser, fakturaer og billetter sendes automatisk.' },
      { icon: '🌐', title: 'Egen hjemmeside', desc: 'Foreningens egen side med sider, nyheder og eget udseende.' },
    ],
    stepsTitle: 'Sådan kommer du i gang',
    steps: [
      { num: 1, title: 'Send en forespørgsel', desc: 'Fortæl os om foreningen, så sætter vi jeres side op.' },
      { num: 2, title: 'Sæt op', desc: 'Læg lokaler, medlemskabstyper og priser ind.' },
      { num: 3, title: 'Tag det i brug', desc: 'Tag imod bookinger, sælg billetter og send fakturaer.' },
    ],
    ctaTitle: 'Klar til at forenkle foreningslivet?',
    ctaText: 'Start gratis i dag. Ingen binding.',
    ctaButton: 'Kom i gang gratis',
    heroImageAlt: 'Oversigten i administrationen for en demoforening',
  },

  features: {
    heroTitle: 'Kraftfulde funktioner til din forening',
    heroSubtitle: 'Medlemmer, udlejning, arrangementer, fakturering og regnskab i én platform.',
    list: [
      {
        icon: '👥',
        title: 'Medlemsadministration',
        description: 'Medlemmer, medlemskaber og husstande samlet ét sted.',
        details: [
          'Medlemskabstyper og husstand med børn',
          'Fornyelse med faktura',
          'Frivilligt arbejde og timer',
        ],
      },
      {
        icon: '🏠',
        title: 'Udlejning af lokaler',
        description: 'Modtag og følg op på bookinger.',
        details: [
          'Priser, tillæg og helligdage',
          'Kontrakt der underskrives online',
          'Depositum og faktura',
        ],
      },
      {
        icon: '📅',
        title: 'Arrangementer',
        description: 'Sælg billetter og slip de rigtige personer ind.',
        details: [
          'Billetsalg med kapacitet',
          'Billettyper i rækkefølge, for eksempel early bird og dørsalg',
          'QR-kode ved døren',
        ],
      },
      {
        icon: '💳',
        title: 'Faktura og betaling',
        description: 'Fakturaer og kreditnotaer, og kortbetaling.',
        details: ['Faktura med rykker', 'Kort og Vipps via Nets', 'Regnskab og kontoplan'],
      },
      {
        icon: '📧',
        title: 'Kommunikation',
        description: 'Beskeder sendes automatisk på det rette tidspunkt.',
        details: ['E-mail og SMS', 'Skabeloner på flere sprog', 'Varsler på det rette tidspunkt'],
      },
      {
        icon: '🌐',
        title: 'Egen hjemmeside',
        description: 'Foreningens egen side med sider og nyheder.',
        details: ['Sider og nyheder', 'Tre udseender og egne farver', 'Eget domæne (sættes op af os)'],
      },
      {
        icon: '🔐',
        title: 'Sikkerhed og privatliv',
        description: 'Hver forening er adskilt fra de andre.',
        details: [
          'Totrinsindlogning',
          'Data lagres i Norge',
          'Indsigt, eksport og sletning af personoplysninger',
        ],
      },
    ],
    ctaTitle: 'Klar til at komme i gang?',
    ctaText: 'Start gratis i dag og oplev, hvor nemt det kan være at drive en forening.',
    ctaButton: 'Kom i gang gratis',
    screensTitle: 'Sådan ser det ud',
    screensSubtitle:
      'Skærmbilleder fra en demoforening med opdigtede data. Administrationen er på norsk.',
    screens: [
      { title: 'Oversigt', text: 'Det der skal følges op, og hvad der sker fremover, på én side.' },
      { title: 'Bookinger', text: 'Forespørgsler, bekræftelser og status for alle bookinger.' },
      { title: 'Kalender', text: 'Besøgende ser, hvornår lokalerne er ledige, og hvad der sker i huset.' },
      { title: 'Billetter', text: 'Salg pr. billettype, deltagere og indtjekning.' },
      { title: 'Vælg plads', text: 'Køberen vælger sine pladser på kortet over lokalet.' },
      { title: 'Salsplan', text: 'Træk borde, stole, scene og bar ind på kortet, med plantegningen som baggrund.' },
      { title: 'Medlemskab', text: 'Medlemmer, medlemskabstyper og husstande.' },
      { title: 'Fakturaer', text: 'Fakturaer og kreditnotaer med status, forfaldsdato og udestående beløb.' },
      { title: 'På telefonen', text: 'Foreningens hjemmeside virker på telefonen.' },
    ],
  },

  pricing: {
    heroTitle: 'Enkel og gennemsigtig prissætning',
    heroSubtitle: 'Vælg den plan der passer til din forening.',
    loading: 'Indlæser priser...',
    loadError: 'Kunne ikke hente opdaterede priser. Viser gemte priser.',
    popular: 'Mest populær',
    perMonth: 'kr./md.',
    unlimited: 'Ubegrænset',
    unlimitedMembers: 'Ubegrænset antal medlemmer',
    upToMembers: 'Op til {count} medlemmer',
    prioritySupport: 'Prioriteret support: vi går i gang inden for 30 minutter, hverdage 09–15',
    planDescFree: 'Til små foreninger',
    planDescStandard: 'Til aktive foreninger',
    planDescAdvanced: 'Til store organisationer',
    ctaFree: 'Kom i gang gratis',
    ctaTrial: 'Send en forespørgsel',
    faqTitle: 'Ofte stillede spørgsmål',
    faq: [
      { q: 'Kan jeg skifte plan når som helst?', a: 'Ja, kontakt os, så skifter vi planen.' },
      { q: 'Hvad sker der, hvis vi overskrider medlemsgrænsen?', a: 'Vi kontakter jer og aftaler en opgradering. Intet lukkes, uden at vi har talt med jer.' },
      { q: 'Er der binding?', a: 'Nej, alle planer kan opsiges når som helst.' },
      { q: 'Tilbyder I rabatter til almennyttige organisationer?', a: 'Ja, kontakt os for særlige priser til almennyttige organisationer.' },
      { q: 'Hvad koster kortbetaling?', a: 'Kort og Vipps går via Nets. Foreningen har en egen aftale med Nets og betaler gebyret direkte til dem.' },
    ],
    emailSms: 'E-mail og SMS',
    bookingsPerMonth: '{count} bookinger om måneden',
    unlimitedBookings: 'Ubegrænsede bookinger',
    ticketsPerMonth: '{count} billetter om måneden',
    unlimitedTickets: 'Ubegrænsede billetter',
    locations: 'Op til {count} lokaler',
    unlimitedLocations: 'Ubegrænsede lokaler',
    storage: '{size} lagerplads',
    customBranding: 'Eget udseende og egne farver',
    exportCsv: 'Eksport til CSV',
    introNotice:
      'I en indledende periode er alle planer gratis. Vi varsler mindst 30 dage, før faktureringen starter.',
  },

  contact: {
    heroTitle: 'Kontakt os',
    heroSubtitle: 'Vi er her for at hjælpe. Skriv til os, så svarer vi så hurtigt vi kan.',
    formTitle: 'Skriv til os',
    formIntro:
      'Har du spørgsmål om CommunityNord, priser, eller hvordan vi kan hjælpe din forening? Udfyld formularen, eller send os en e-mail.',
    email: 'E-mail',
    name: 'Navn',
    organization: 'Forening/Organisation',
    subject: 'Emne',
    chooseSubject: 'Vælg emne',
    subjectGeneral: 'Generelt spørgsmål',
    subjectPricing: 'Priser og abonnement',
    subjectSupport: 'Teknisk support',
    subjectDemo: 'Anmod om demo',
    subjectPartnership: 'Samarbejde',
    message: 'Besked',
    send: 'Send besked',
    success: 'Tak! Vi har modtaget din henvendelse og vender tilbage, så snart vi kan.',
    error: 'Noget gik galt. Prøv igen, eller send os en e-mail.',
    tooMany: 'Du har sendt mange henvendelser. Prøv igen senere, eller send os en e-mail.',
    sending: 'Sender...',
    supportNote:
      'Standard og Avanceret har prioriteret support: vi går i gang med sagen inden for 30 minutter, hverdage 09–15.',
  },

  login: {
    title: 'Log ind',
    subtitle:
      'Hver forening har sin egen indlogning. Skriv foreningens adresse, så tager vi dig derhen.',
    label: 'Foreningens adresse',
    placeholder: 'foreningen',
    button: 'Gå til indlogning',
    hint:
      'Har foreningen eget domæne, bruger du det i stedet. Kan du ikke finde adressen, så spørg bestyrelsen eller kontakt os.',
    invalid: 'Brug kun små bogstaver, tal og bindestreg.',
  },

  signup: {
    heroTitle: 'Kom i gang med CommunityNord',
    heroSubtitle:
      'Udfyld formularen for at oprette en ny forening. Vi sender dig en e-mail, når din konto er klar.',
    formTitle: 'Opret ny forening',
    success:
      'Tak for din henvendelse! Vi har modtaget din forespørgsel og kontakter dig, så snart din konto er klar.',
    error: 'Der opstod en fejl ved indsendelsen. Prøv venligst igen eller kontakt os.',
    orgName: 'Organisationsnavn',
    orgNamePlaceholder: 'Foreningens navn',
    contactPerson: 'Kontaktperson',
    contactPersonPlaceholder: 'Dit fulde navn',
    email: 'E-mail',
    phone: 'Telefon',
    plan: 'Ønsket abonnement',
    messageOptional: 'Besked (valgfrit)',
    messagePlaceholder: 'Fortæl os lidt om din forening...',
    sending: 'Sender...',
    submit: 'Send forespørgsel',
    free: 'Gratis',
    perMonth: 'kr./md.',
    upTo50: 'Op til 50 medlemmer',
    upTo500: 'Op til 500 medlemmer',
    unlimitedMembers: 'Ubegrænset antal medlemmer',
    nextTitle: 'Hvad sker der nu?',
    nextSteps: [
      { title: 'Ansøgning sendt', desc: 'Vi modtager din ansøgning og sender en bekræftelse til din e-mail.' },
      { title: 'Behandling', desc: 'Vores team behandler din ansøgning, normalt inden for 1-2 hverdage.' },
      { title: 'Velkommen', desc: 'Du får et invitationslink på e-mail til at oprette din konto.' },
    ],
    questionsTitle: 'Har du spørgsmål?',
    questionsContact: 'Kontakt os på',
  },

  onboarding: {
    homeTitle: 'CommunityNord Onboarding',
    homeSubtitle:
      'For at oprette en ny organisation skal du bruge et invitationslink. Kontakt en administrator for at få et tilsendt.',
    homeGotLink: 'Har du modtaget et link?',
    homeGotLinkText:
      'Klik på linket, du har fået tilsendt via e-mail, for at starte opsætningen af din organisation.',
    homeBack: '← Tilbage til communitynord.com',
    validating: 'Validerer invitationen...',
    invalidTitle: 'Ugyldig invitation',
    invalidContact: 'Kontakt administratoren for at få et nyt invitationslink.',
    connectError: 'Kunne ikke få forbindelse til serveren. Prøv igen senere.',
    deviceBound:
      'Dette link er allerede åbnet på en anden enhed og er knyttet til den. Åbn linket på den første enhed for at fortsætte, eller skriv til support@communitynord.com, så sender vi et nyt link.',
    genericError: 'Noget gik galt. Prøv igen.',
    steps: ['Velkommen', 'Organisation', 'Kontakt', 'Brugerkonto', 'Bekræft'],
    step1Title: 'Velkommen til CommunityNord',
    step1Subtitle:
      'Du er inviteret til at oprette en ny organisation. Vi guider dig gennem opsætningen trin for trin.',
    step1Suggested: 'Foreslået navn:',
    step1SentTo: 'Invitation sendt til:',
    step1Expires: 'Invitationen udløber:',
    step1Needs: 'Det skal du bruge:',
    step1NeedsList: [
      'Organisationens navn',
      'Kontaktoplysninger',
      'Eventuelt CVR-/organisationsnummer',
      'Ønsket brugernavn og adgangskode',
    ],
    step1Start: 'Kom i gang →',
    back: '← Tilbage',
    next: 'Næste →',
    step2Title: 'Om organisationen',
    step2Subtitle: 'Fortæl os om organisationen, der skal bruge platformen.',
    orgName: 'Organisationsnavn',
    orgNamePlaceholder: 'F.eks. Aarhus Ungdomshus',
    orgNameRequired: 'Organisationsnavn er påkrævet',
    slug: 'URL-præfiks (slug)',
    slugRequired: 'URL-præfiks er påkrævet',
    slugFormat: 'Kun små bogstaver, tal og bindestreger',
    slugMin: 'Mindst 2 tegn',
    shortName: 'Kortnavn',
    shortNameRequired: 'Kortnavn er påkrævet',
    shortNameMax: 'Maks. 10 tegn',
    shortNameFormat: 'Kun bogstaver og tal',
    shortNameHint: 'Bruges som præfiks i fakturanumre m.m.',
    customDomain: 'Eget domæne',
    customDomainPlaceholder: 'f.eks. eksempel.dk',
    customDomainHint: 'Valgfrit. Giver adgang via eget domæne ud over subdomænet.',
    customDomainNoProtocol: 'Skriv kun domænet, uden http:// eller https://',
    customDomainNoPath: 'Skriv kun domænet, uden sti',
    customDomainInvalid: 'Ugyldigt domæneformat',
    country: 'Land',
    countryHint: 'Landet organisationen hører hjemme i',
    countryNames: { NO: 'Norge', SE: 'Sverige', DK: 'Danmark' },
    orgNumber: 'Organisationsnummer',
    orgNumberHint: 'Valgfrit. CVR-/organisationsnummer.',
    appearance: 'Udseende',
    layout: 'Hjemmesidens udseende',
    layoutHint: 'Kan ændres når som helst under Admin → Branding.',
    layouts: [
      { key: 'classic', name: 'Klassisk', description: 'Traditionelt layout med centreret indhold og logo til venstre. Passer til de fleste.' },
      { key: 'modern', name: 'Moderne', description: 'Forside i fuld bredde og kompakt menu. Frisk og luftig stil.' },
      { key: 'compact', name: 'Kompakt', description: 'Minimal luft og tæt information. Godt til indholdsrige sider.' },
      { key: 'custom', name: 'Skræddersyet', description: 'Eget design lavet i samarbejde med os. Vi kontakter jer.' },
    ],
    tagline: 'Slogan / motto',
    taglinePlaceholder: 'F.eks. »Sammen skaber vi aktivitet«',
    taglineHint: 'Valgfrit. Vises i sidefoden på hjemmesiden.',
    logo: 'Logo',
    logoUpload: 'Upload logo',
    logoChange: 'Skift billede',
    logoRemove: 'Fjern',
    logoHint: 'Valgfrit. PNG/JPG/SVG, maks. 2 MB. Kan også tilføjes senere.',
    logoTooBig: 'Billedet er for stort (maks. 2 MB)',
    logoNotImage: 'Filen skal være et billede',
    logoUseUrl: 'Brug URL i stedet',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Absolut URL til logoet (https://...).',
    subscriptionPlan: 'Abonnementsplan',
    subscriptionPlanHint: 'Planen sættes som startplan og kan ændres i portalen senere.',
    step3Title: 'Kontaktoplysninger',
    step3Subtitle: 'Hvem er hovedkontakt for organisationen? Denne person bliver ejer af kontoen.',
    contactPerson: 'Kontaktperson',
    contactPersonRequired: 'Kontaktperson er påkrævet',
    email: 'E-mailadresse',
    emailRequired: 'E-mail er påkrævet',
    emailInvalid: 'Ugyldig e-mailadresse',
    phone: 'Telefonnummer',
    postalAddress: 'Postadresse',
    optional: '(valgfrit)',
    streetAddress: 'Gadeadresse',
    city: 'By',
    postalCode: 'Postnr.',
    sameAsPostal: 'Besøgsadressen er den samme som postadressen',
    visitingAddress: 'Besøgsadresse',
    step4Title: 'Opret brugerkonto',
    step4Subtitle:
      'Denne bruger bliver ejer af organisationen med fuld adgang. Du kan tilføje flere brugere senere.',
    username: 'Brugernavn',
    usernameRequired: 'Brugernavn er påkrævet',
    usernameMin: 'Mindst 3 tegn',
    usernameMax: 'Maks. 256 tegn',
    usernameEmailInvalid: 'Ugyldigt e-mailformat',
    usernameFormat:
      'Brug brugernavnsformat (a-z, 0-9, punktum, bundstreg, bindestreg) eller en gyldig e-mailadresse',
    usernamePlaceholder: 'jens.jensen eller navn@domæne.dk',
    usernameHint: 'Bruges til login. Kan være brugernavn eller e-mailadresse.',
    loginEmail: 'E-mail (til login)',
    loginEmailHint: 'Hentet fra kontaktoplysningerne i forrige trin.',
    password: 'Adgangskode',
    passwordRequired: 'Adgangskode er påkrævet',
    passwordMin: 'Mindst 8 tegn',
    passwordShow: 'Vis',
    passwordHide: 'Skjul',
    passwordHint: 'Tip: Brug en kombination af store/små bogstaver, tal og specialtegn.',
    passwordConfirm: 'Bekræft adgangskode',
    passwordConfirmPlaceholder: 'Gentag adgangskoden',
    passwordMismatch: 'Adgangskoderne er ikke ens',
    step5Title: 'Bekræft og opret',
    step5Subtitle:
      'Gennemgå oplysningerne, før du opretter organisationen. Du kan gå tilbage for at lave ændringer.',
    reviewOrg: 'Organisation',
    reviewName: 'Navn',
    reviewUrl: 'URL',
    reviewCustomDomain: 'Eget domæne',
    reviewCountry: 'Land',
    reviewShortName: 'Kortnavn',
    reviewOrgNumber: 'Org.nr.',
    reviewPlan: 'Abonnement',
    reviewLayout: 'Udseende',
    reviewTagline: 'Slogan',
    reviewLogo: 'Logo',
    reviewContact: 'Kontakt',
    reviewContactPerson: 'Kontaktperson',
    reviewEmail: 'E-mail',
    reviewPhone: 'Telefon',
    reviewPostal: 'Postadresse',
    reviewVisiting: 'Besøgsadresse',
    reviewAddress: 'Adresse',
    reviewPlace: 'By',
    reviewAccount: 'Brugerkonto',
    reviewUsername: 'Brugernavn',
    reviewPassword: 'Adgangskode',
    reviewRole: 'Rolle',
    reviewOwner: 'Ejer (Owner)',
    creating: 'Opretter...',
    create: 'Opret organisation ✓',
    successTitle: '{name} er oprettet!',
    successAwaiting:
      'Vi klargør nu jeres hjemmeside — dette er et manuelt trin, hvor vi kontrollerer, at alt er sat rigtigt op. I får en e-mail til {email}, så snart siden er klar til brug.',
    successAwaitingNoEmail:
      'Vi klargør nu jeres hjemmeside — dette er et manuelt trin, hvor vi kontrollerer, at alt er sat rigtigt op. I får en e-mail, så snart siden er klar til brug.',
    successWhatNow: 'Hvad sker der nu?',
    successStep1: 'Vi kontrollerer opsætningen og gør siden klar. Det tager normalt kort tid.',
    successStep2: 'I får en e-mail, når siden er klar, med et link til login.',
    successStep3: 'Log ind med brugernavnet {username} og den adgangskode, I valgte.',
    successDetails: 'Dine oplysninger',
    successOrg: 'Organisation',
    successUrl: 'Webadresse',
    successUsername: 'Brugernavn',
    successDnsTitle: 'Eget domæne: {domain}',
    successDnsIntro:
      'For at {domain} skal pege på jeres hjemmeside, skal DNS-indstillingerne hos jeres domæneudbyder opdateres. Vælg en af mulighederne:',
    successDnsCnameTitle: 'Mulighed 1 — CNAME (nemmest)',
    successDnsCnameText: 'Opret en CNAME-post, der peger på jeres subdomæne:',
    successDnsATitle: 'Mulighed 2 — A-post',
    successDnsAText: 'Peg domænet direkte på vores server-IP:',
    successDnsNote:
      'DNS-ændringer kan tage op til nogle timer at træde i kraft. Bemærk: en CNAME kan ikke bruges på et roddomæne (eksempel.dk) hos alle udbydere — brug i så fald en A-post, eller CNAME på www. Vi verificerer domænet som en del af klargøringen.',
    successDnsType: 'Type',
    successDnsName: 'Navn/vært',
    successDnsValue: 'Værdi/mål',
  },
}
